var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"du-loading-wrapper",class:{
      'pure-white-background': _vm.pureWhiteBackground,
      'du-loading-no-text': !_vm.text
    }},[_c('div',{staticClass:"du-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"du-loading-icon-wrapper"},[_c('img',{staticClass:"du-loading du-icon_toast",attrs:{"src":_vm.imgResize(
            'https://cdn.poizon.com/node-common/613efd3199de16106b0b9e1f8549623c.png',
            108
          ),"alt":""}}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"du-toast__content"},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }